import { Application } from "@hotwired/stimulus"
import "flowbite/lib/esm/index.turbo.js"
import "./admin/flowbite_datepicker.js"
import "./admin/flowbite_modal.js"

const application = Application.start()

// Configure Stimulus development experience
application.debug = true
window.Stimulus   = application

export { application }